import { createAction, props } from '@ngrx/store';

export const setStudyId = createAction(
  '[Entity] Set Study ID',
  props<{ study_id: string }>(),
);

export const setSiteId = createAction(
  '[Entity] Set Site ID',
  props<{ site_id: string }>(),
);

